import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  firstToKnow: {
    id: 'notifyMe.firstToKnow',
    defaultMessage: 'Be the first to know when they arrive in store.',
  },
  subscribedMsg: {
    id: 'notifyMe.subscribedMsg',
    defaultMessage: 'Your subscription has been submitted.',
  },
  subscribedMsgGuest: {
    id: 'notifyMe.subscriptionConfirmationMessage',
    defaultMessage:
      'We have sent an email to the address you entered during registration. Click on the link to confirm your email address. It may take a few minutes to receive a confirmation email. If you do not receive a confirmation email, be sure to check your spam folder.',
  },
  title: {
    id: 'notifyMe.title',
    defaultMessage: 'NOTIFY ME',
  },
  emptyResults: {
    id: 'notifyMe.emptyResults',
    defaultMessage: 'Failed to get product information.',
  },
});
